import {Component} from '@angular/core';

@Component({
  selector: 'cui-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.scss']
})
export class CuiUserManualComponent {

}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/help/user-manual/user-manual.component.ts